@if (initError()) {
  <div>Unable to load Stripe</div>
}
<div class="container" #stripeContainer></div>
<div class="mat-caption error">
  @if (errorMessage$ | async; as errorMessage) {
    {{ errorMessage }}
  }
</div>
